import React from "react";
import * as W from "./WarningComunicadoStyle";
import { FaShieldAlt } from "react-icons/fa";

export default function WarningComunicadoSaque({ onClose }) {
  return (
    <W.WarningOverlay>
      <W.WarningContainer>
        <W.TopAccent />

        <W.Header>
          <W.IconCircle>
            <FaShieldAlt />
          </W.IconCircle>
          <W.Badge>Comunicado</W.Badge>
          <W.Title>Auditoria e Validação de Dados</W.Title>
          <W.Divider />
        </W.Header>

        <W.Body>
          <W.TextContent>
            <p>
              Seu cadastro está em processo de auditoria e validação de
              informações.
            </p>

            <W.Highlight>
              Durante este período, os recebimentos dos seus royalties poderão
              permanecer temporariamente suspensos por até <strong>60 dias</strong>.
              Após a conclusão da análise, os recebimentos retornarão normalmente.
            </W.Highlight>

            <p>A Golden Brasil agradece sua compreensão e confiança.</p>
          </W.TextContent>
        </W.Body>

        <W.Footer>
          <W.AcceptButton onClick={onClose}>Estou ciente</W.AcceptButton>
        </W.Footer>
      </W.WarningContainer>
    </W.WarningOverlay>
  );
}
